import { initializeClientSubApplication } from "./load-application";
import FileBaseListSplit from "../components/FileBaseListSplit";

initializeClientSubApplication("filebase-list-react-", FileBaseListSplit);
